import { render, staticRenderFns } from "./VideoInfo.vue?vue&type=template&id=f1dbbbf8&scoped=true"
import script from "./VideoInfo.vue?vue&type=script&lang=js"
export * from "./VideoInfo.vue?vue&type=script&lang=js"
import style0 from "./VideoInfo.vue?vue&type=style&index=0&id=f1dbbbf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dbbbf8",
  null
  
)

export default component.exports